import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';

import { withZippiaHistory } from 'hooks';

import { openSignUpModal } from '../../store/modals/actions';

import styles from './WhatIsZippia.module.css';
import classNames from 'classnames';

const propTypes = {
  zippiaHistory: PropTypes.any.isRequired,
  openSignUpModal: PropTypes.func.isRequired,
};

class WhatIsZippia extends Component {
  personalizedJobs = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const { zippiaHistory, openSignUpModal } = this.props;

    const query = {
      survey: '030',
      survey_step: 'step1',
    };
    openSignUpModal({
      ...query,
      popupType: 'what-is-zippia',
    }).then(() => {
      zippiaHistory.pushQuery(query);
    });
  };

  render() {
    return (
      <section className={`section ${styles['what-zippia-sec']}`}>
        <div className="container">
          <div className={`${styles['sec-head']} col-lg-12 no-side-padding`}>
            <h1
              className={classNames(
                styles['displayHeading1'],
                'text-uppercase',
                'text-center',
                'z-mb-30'
              )}
            >
              Get the job you really want
            </h1>
            <div className="cb-med blue-text text-uppercase no-side-padding col-lg-6 offset-lg-3">
              <h2 className="brandonH2">The information and tools to find your next job</h2>
            </div>
            <div className="no-side-padding col-lg-8 offset-lg-2">
              <p>
                Zippia helps you find and pursue the job that&apos;s right for your career. 
                Other job sites display jobs, but they don&apos;t care how those jobs fit into your longer term career goals. 
                We believe that every job seeker should have access to a full set of career information to better evaluate and choose a job. 
              </p>
            </div>
          </div>

          <div className={styles['sec-body']}>
            <div className="row">
              <div className="col-lg-3">
                <div className={styles['col-unit']}>
                  <div className={styles['unit-head']}>
                    <span onClick={this.personalizedJobs}>
                      <div
                        className={`rounded-circle icon-icon-personalized ${styles['icon-personalized-bg']}`}
                      />
                    </span>
                  </div>
                  <div className={styles['unit-body']}>
                    <h3 className={`semi-bold-font zippia-blue-text mt-3 text-capitalize`}>
                      <span onClick={this.personalizedJobs}>Personalized jobs</span>
                    </h3>
                    <p>
                      Get job recommendations based on your background, workplace preferences, and 
                      career goals.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className={styles['col-unit']}>
                  <div className={styles['unit-head']}>
                    <a href="/company/">
                      <div
                        className={`rounded-circle icon-icon-company ${styles['icon-company-bg']}`}
                      />
                    </a>
                  </div>
                  <div className={styles['unit-body']}>
                    <h3 className="semi-bold-font zippia-blue-text mt-3 text-capitalize">
                      <a href="/company/">Company insights</a>
                    </h3>
                    <p>
                      Understand a company’s culture before you apply for a job through reviews, financial performance, and salaries.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className={styles['col-unit']}>
                  <div className={styles['unit-head']}>
                    <a href="/careers/">
                      <div className={`rounded-circle icon-icon-job ${styles['icon-job-bg']}`} />
                    </a>
                  </div>
                  <div className={styles['unit-body']}>
                    <h3 className="semi-bold-font zippia-blue-text mt-3 text-capitalize">
                      <a href="/careers/">Job insights</a>
                    </h3>
                    <p>
                      Discover new career options based on your skill set, including salaries, job
                      responsibilities, and more.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className={styles['col-unit']}>
                  <div className={styles['unit-head']}>
                    <a href="/colleges-and-majors/">
                      <div
                        className={`rounded-circle icon-icon-careerpaths ${styles['icon-careerpaths-bg']}`}
                      />
                    </a>
                  </div>
                  <div className={styles['unit-body']}>
                    <h3 className="semi-bold-font zippia-blue-text mt-3 text-capitalize">
                      <a href="/colleges-and-majors/">Career paths</a>
                    </h3>
                    <p>
                      Visualize how professionals with a similar background have navigated their careers.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

WhatIsZippia.propTypes = propTypes;

const mapDispatchToProps = {
  openSignUpModal,
};

export default withZippiaHistory(
  connect(
    ({ locals, modals }) => ({
      locals,
      modals,
    }),
    mapDispatchToProps
  )(WhatIsZippia)
);
